import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BTargetFetchListCard } from './BTargetFetchListCard'
export const BTargetPopperListCard = defineComponent({
  name: 'BTargetPopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids, coreIds: this.coreIds }} tippyConfig={getAsyncListTippyConfig()} component={BTargetFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
